document.addEventListener('DOMContentLoaded', function() {
  var closeIcon = document.querySelector('.close-icon');
  var continueShoppingButton = document.querySelector('.stay-btn');
  var miniCart = document.querySelector('.mini-cart');
  var cartCountElement = document.querySelector('#cart-count');
  var header = document.querySelector('.main-header'); 
  var lastItemCount = parseInt(localStorage.getItem('lastItemCount'), 10) || 0;
  var popupShown = localStorage.getItem('popupShown') === 'true';

  function hideMiniCart() {
    miniCart.classList.remove('visible');
    if (header) {
      header.style.position = ''; 
    }
    localStorage.removeItem('popupShown');
  }

  function showMiniCart() {
    miniCart.classList.add('visible');
    if (header) {
      header.style.position = 'fixed'; 
      header.style.top = '0'; 
      header.style.left = '0'; 
      header.style.width = '100%'; 
      header.style.zIndex = '1000'; 
    }
    localStorage.setItem('popupShown', 'true');
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        var currentItemCount = cart.item_count;

        if (cartCountElement) {
          cartCountElement.textContent = currentItemCount;
          cartCountElement.dataset.itemCount = currentItemCount;
        }

        if (currentItemCount > lastItemCount && !popupShown) {
          showMiniCart();
        } else if (currentItemCount === 0) {
          hideMiniCart();
        }

        lastItemCount = currentItemCount;
        localStorage.setItem('lastItemCount', currentItemCount);
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  function handleBodyClick(evt) {
    if (!miniCart.contains(evt.target) && !evt.target.closest('.mini-cart')) {
      hideMiniCart();
    }
  }

  function adjustMiniCartStyles() {
    if (window.innerWidth <= 760) {
      miniCart.style.width = '100%';
      miniCart.style.padding = '1rem';
      miniCart.style.boxSizing = 'border-box';
      miniCart.style.position = 'fixed';
      miniCart.style.left = '0';
      miniCart.style.top = '80px';
      miniCart.style.transform = 'translateY(0)';
      miniCart.style.overflowY = 'auto';
      miniCart.style.maxHeight = '90vh';
    } else {
      miniCart.style.width = '';
      miniCart.style.padding = '';
      miniCart.style.boxSizing = '';
      miniCart.style.position = '';
      miniCart.style.left = '';
      miniCart.style.top = '';
      miniCart.style.transform = '';
      miniCart.style.overflowY = '';
      miniCart.style.maxHeight = '';
    }
  }

  if (popupShown) {
    miniCart.classList.add('visible');
  } else {
    miniCart.classList.remove('visible');
  }

  updateCartCount();

  if (closeIcon) {
    closeIcon.addEventListener('click', hideMiniCart);
  }
  if (continueShoppingButton) {
    continueShoppingButton.addEventListener('click', hideMiniCart);
  }

  document.body.addEventListener('click', handleBodyClick);

 
  setInterval(updateCartCount, 500); // 1秒から0.5秒に変更

  adjustMiniCartStyles();

  window.addEventListener('resize', adjustMiniCartStyles);
});
